













































import Vue from 'vue';
import UserPage from '../components/UserPage.vue';
import UserFormField from '../components/UserFormField.vue';
import { Scene } from '../models/SmsVerify';
import userClient from '../apis';

const mobile: string | null = null;
const code: string | null = null;
const secretKey: string | null = null;
const repassword: string | null = null;
const password: string | null = null;
const description: string | null = '验证身份';
const captchaObj: any | null = null;

export default Vue.extend({
  components: {
    UserPage,
    UserFormField,
  },
  data() {
    return {
      mobile,
      code,
      showWarning: false,
      warningText: '',
      sendedVerifyCode: false,
      isSending: false,
      sendingText: '',
      inited: false,
      initGeetest: false,
      checkSuccess: false,
      secretKey,
      password,
      repassword,
      description,
      pageTitle: '找回密码',
      resetStatus: false,
      captchaObj,
    };
  },
  methods: {
    checkCode() {
      if (!this.validateMobile(this.mobile)) {
        this.$Message.error('请输入正确的手机号码');
        return;
      }
      if (this.code === null || this.code === '') {
        this.$Message.error('请输入验证码');
        return;
      }
      userClient.checkCode({
        mobile: this.mobile,
        code: this.code,
        scene: Scene.UserForget,
      }).success((r) => {
        if (r.status) {
          this.checkSuccess = true;
          this.showWarning = false;
          this.secretKey = r.secretKey;
          this.description = '验证成功，重设密码';
        } else {
          this.showWarning = true;
          this.warningText = '验证码错误';
        }
      });
    },
    resetPassword() {
      if (!this.validatePassword(this.password)) {
        this.$Message.error('密码格式不正确');
        return;
      }
      if (this.password !== this.repassword) {
        this.$Message.error('两次密码不一致');
        return;
      }
      this.showWarning = false;
      userClient.resetPassword({
        password: this.password,
        secretKey: this.secretKey,
      }).success((r) => {
        if (r.code === 0) {
          this.pageTitle = '密码设置成功';
          this.description = null;
          this.resetStatus = true;
          setTimeout(function() {
            window.location.href = '#/user/login';
          }, 3000);
        } else {
          this.showWarning = true;
          this.warningText = r.message;
        }
      });
    },
    sendVerifyCode() {
      if (!this.validateMobile(this.mobile)) {
        this.$Message.error('请输入正确的手机号码');
      } else {
        userClient.checkMobileRegister({
          mobile: this.mobile,
        }).success((r) => {
          if (r) {
            this.showWarning = false;
            this.captchaObj.verify();
          } else {
            this.showWarning = true;
            this.warningText = '该号码还未被注册，请先注册';
          }
        });
      }
    },
    sendSmsCode() {
      userClient.sendSmsCode({
        mobile: this.mobile,
        scene: Scene.UserForget,
      }).success(() => {
        this.countDown(300);
      });
    },
    countDown(remain: number) {
      this.sendedVerifyCode = true;
      const downCountInterval = setInterval(() => {
        remain -= 1;
        if (remain <= 0) {
          clearInterval(downCountInterval);
          this.sendedVerifyCode = false;
        } else {
          this.sendingText = '重新发送（' + remain + '）';
        }
      }, 1000);
    },
    validatePassword(password: string | null) {
      const re = /(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*])[a-z\d#@!~%^&*]{6,16}/i;
      return password !== null && re.test(password);
    },
    validateMobile(mobile: string | null) {
      const re = /^1[3|4|5|8][0-9]\d{8}$/;
      return mobile !== null && re.test(mobile);
    },
    initGtCaptcha() {
      const that = this;
      userClient.getGtCaptcha()
        .success((res) => {
          (window as any).initGeetest({
            gt: res.gt,
            challenge: res.challenge,
            offline: !res.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: true, // 用于宕机时表示是新验证码的宕机
            product: 'bind',
            width: '260px',
          }, function(captchaObj: any) {
            captchaObj.onReady(function() {
              that.inited = true;
              that.initGeetest = true;
              that.captchaObj = captchaObj;
            }).onSuccess(function() {
              that.sendSmsCode();
            }).onError(function() {
              that.$Message.error('出错啦，请刷新页面进行重试');
            });
          // document.getElementById('sendVerifyCode')!.addEventListener('click', function() {
          //   if (!that.validateMobile(that.mobile)) {
          //     that.$Message.error('请输入正确的手机号码');
          //   } else {
          //     userClient.checkMobileRegister({
          //       mobile: that.mobile,
          //     }).success((r) => {
          //       if (r) {
          //         that.showWarning = false;
          //         captchaObj.verify();
          //       } else {
          //         that.showWarning = true;
          //         that.warningText = '该号码还未被注册，请先注册';
          //       }
          //     });
          //   }
          // });
          });
        }).error(() => {
          that.inited = true;
        });
    },
  },
  mounted() {
    this.initGtCaptcha();
  },
});

